// Column keys double as the backend sort keys (SecretaryFilters::SORTABLE) so ResponsiveTable's
// sort arrows light up against `filters.sort` with no translation layer. Phone is not sortable —
// matches the legacy DataTable definition (no `sortable`/`representedAs` on that column).
export function buildColumns() {
  return [
    { key: 'first_name', label: 'First Name', sortable: true, minWidth: '110px', width: '1fr' },
    { key: 'last_name', label: 'Last Name', sortable: true, minWidth: '150px', width: '1.6fr' },
    { key: 'committee_name', label: 'Committee Name', sortable: true, minWidth: '150px', width: '2fr' },
    { key: 'phone', label: 'Phone', minWidth: '110px', width: '1fr' },
    // Fixed px, not minWidth+fr (see Horses' `remove` column for why a shared px value —
    // not max-content — is what keeps header/row column edges aligned): sized to the wider of
    // the "Action" header label and the shrunk .secretary-login-btn button.
    { key: 'login', label: 'Action', width: '80px', cellClass: 'text-center' }
  ]
}

// Below 700px the row collapses into an accordion: a combined First+Last name summary (the
// legacy expandedHeader showed both names together) plus the same detail fields the legacy
// expandedRow showed (Phone, Login).
export function buildBreakpoints() {
  return [
    {
      maxWidth: 700,
      hideHeader: true,
      accordion: {
        summary: [{ keys: ['name'], hideLabel: true }]
      },
      rows: [
        ['committee_name'],
        ['phone'],
        ['login']
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/Admin/Listing/secretaryUsersColumns.js